import Container from "../../components/container";
import { Col, Row } from "antd";
import PageHeader from "../../components/PageHeader";
import UserOnboardingForm from "../new-workspace/myprofile.workspace";

const MyProfile = () => {
  return (
    <Container>
      <Row className="mt-[24px]">
        <Col xs={24} lg={{ span: 12, offset: 6 }}>
          <PageHeader
            title={"My Profile"}
            description={"Keep your personal information up to date"}
            backBtn={false}
          />
          <UserOnboardingForm
            myprofile={true}
            isProfileSetting={true}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default MyProfile;
